import React from 'react'
import { Box, Grid } from '@mui/material'
import { PropTypes } from 'prop-types'

import { ColorBoxContent, ColorBoxHeader } from '../../ui/colorBox'

const PageLayout = ({ header, children }) => {
  return (
    <Grid
      container
      direction='column'
      justifyContent='flex-start'
      alignItems='stretch'
      spacing={2}
    >
      <Grid item>
        <ColorBoxHeader>{header}</ColorBoxHeader>
      </Grid>
      <Grid item>
        <Box>{children}</Box>
      </Grid>
      <Grid item>
        <ColorBoxContent>© Circles Orbit 2025 </ColorBoxContent>
      </Grid>
    </Grid>
  )
}

PageLayout.propTypes = {
  header: PropTypes.string,
  children: PropTypes.node
}

export default PageLayout
